import { Box, BoxProps } from '@mui/material';
import React from 'react';

type RichTextProps = { children?: string | TrustedHTML | null } & Omit<BoxProps, 'dangerouslySetInnerHTML'>;

export default function RichText({ children, ...boxProps }: RichTextProps) {
    if (!children) {
        return null;
    }

    return <Box dangerouslySetInnerHTML={{ __html: children }} {...boxProps} />;
}
